import React from "react";
import {useTranslation} from "@unibuddy/intl";
import {string} from "yup";
import {Form, FormGroup, SubmitButton, TextInput, Box} from "@unibuddy/patron";
import {FormikHelpers} from "formik";

import {IntlNamespaces} from "../../../../translations/types";
import {INTL_EMAIL, INTL_SEND_LINK} from "../../../../translations/passwordReset";
import {INTL_EMAIL_REQUIRED, INTL_INVALID_EMAIL} from "../../../../translations/validations";

type FormValues = {
    email: string;
};

export type PasswordResetFormProps = {
    onPasswordResetSubmit: (email: string, formActions: FormikHelpers<FormValues>) => Promise<void>;
};

export const PasswordResetForm: React.FC<PasswordResetFormProps> = ({onPasswordResetSubmit}) => {
    const {t} = useTranslation([IntlNamespaces.PASSWORD_RESET, IntlNamespaces.VALIDATIONS]);

    return (
        <Form
            onSubmit={(values: FormValues, formActions: FormikHelpers<FormValues>) =>
                onPasswordResetSubmit(values.email, formActions)
            }
            validationSchema={{
                email: string()
                    .email(
                        t(
                            `${IntlNamespaces.VALIDATIONS}:${INTL_INVALID_EMAIL.key}`,
                            INTL_INVALID_EMAIL.defaultValue,
                        ),
                    )
                    .required(
                        t(
                            `${IntlNamespaces.VALIDATIONS}:${INTL_EMAIL_REQUIRED.key}`,
                            INTL_EMAIL_REQUIRED.defaultValue,
                        ),
                    ),
            }}
        >
            {({isValid}) => {
                return (
                    <>
                        <FormGroup id={"email"} label={t(INTL_EMAIL.key, INTL_EMAIL.defaultValue)}>
                            <TextInput name="email" required />
                        </FormGroup>
                        <Box marginTop="medium" display="flex" justifyContent="center">
                            <SubmitButton color="university" disabled={!isValid} block>
                                {t(INTL_SEND_LINK.key, INTL_SEND_LINK.defaultValue)}
                            </SubmitButton>
                        </Box>
                    </>
                );
            }}
        </Form>
    );
};
